import React, { useEffect, useRef, useState } from 'react';
import { Alert, Form } from 'antd';
import { CalendarOutlined, InfoCircleOutlined } from '@ant-design/icons';
import CalendarFormRender from '../components/Calendar';
import { t } from "@lingui/core/macro";
import { useFormPath } from './index';
import logger from "../../../services/logger";

export default (formPlugin, namespace) => {
    const calendars = formPlugin.formData?.calendars || []

    return {
        Renderer: (props) => {

            const { listFieldProps, buildName } = useFormPath()

            if (props.remove) {
                formPlugin.onAddFormPlugin(props, props.nodeId, props.pluginConfig.id)
            }

            if (!props.data.calendarId) {
                if (!props.isPreviewMode && !props.readOnly) {
                    return (
                        <Alert showIcon type={"warning"} message={t`Veuillez choisir un calendrier.`} />
                    )
                }
                return null
            }

            const { data } = props

            // calendarId stocké au format "Label => id" (legacy) ou juste "id"
            const rawCalendarId = String(data.calendarId || "")
            const calendarId = rawCalendarId.includes("=>")
                ? rawCalendarId.split("=>").pop().trim()
                : rawCalendarId.trim()

            if (!calendarId) {
                return null
            }

            let rules = [{ required: data.required || false, message: t`Ce champ est obligatoire` }]

            let tooltip = null
            if (data.tooltip) {
                tooltip = {
                    title: data.tooltip,
                    icon: <InfoCircleOutlined />,
                }
            }

            const finalName = "[CALENDAR]_" + calendarId
            return (
                <Form.Item
                    {...(listFieldProps || {})}
                    label={data.label}
                    name={buildName(finalName)}
                    rules={rules}
                    tooltip={tooltip}
                >
                    <CalendarFormItem calendarId={calendarId} />
                </Form.Item>
            )
        },
        namespace: namespace,
        id: 'form-calendar' + namespace,
        title: t`Calendrier`,
        description: t`Élément de formulaire utilisable.`,
        icon: <CalendarOutlined />,
        iconColor: "#2980B9",
        version: 1,
        controls: {
            type: 'autoform',
            schema: {
                properties: {
                    required: {
                        type: 'boolean',
                        uniforms: {
                            label: t`Obligatoire`,
                        }
                    },
                    calendarId: {
                        type: 'string',
                        uniforms: {
                            required: true,
                            label: t`Calendrier`,
                            placeholder: t`Calendrier`,
                            allowedValues: calendars.map(i => i.label + " => " + i.id),
                        }
                    },
                    label: {
                        type: 'string',
                        uniforms: {
                            required: false,
                            label: t`Étiquette`,
                            placeholder: t`Libellé`,
                        }
                    },

                    tooltip: {
                        type: 'string',
                        uniforms: {
                            label: t`Message d'aide`,
                            placeholder: t`Message d'aide`,
                            multiline: true,
                            rows: 2,
                        }
                    },
                }
            },
        },
    }

    function CalendarFormItem({ value, onChange, calendarId }) {
        const [slots, setSlots] = useState([])
        const [currentMonthDate, setCurrentMonthDate] = useState(new Date())

        useEffect(() => {
            // Race-safe : on ignore les réponses arrivant après un nouveau changement de mois ou un démontage
            let cancelled = false
            const month = currentMonthDate.getMonth()
            const year = currentMonthDate.getFullYear()
            ;(async () => {
                try {
                    const _slots = await formPlugin.getAvailableCalendarSlots(calendarId, month, year)
                    if (!cancelled) setSlots(_slots || [])
                } catch (e) {
                    if (!cancelled) setSlots([])
                    logger.error({ err: e }, "[calendar] getAvailableCalendarSlots failed")
                }
            })()
            return () => { cancelled = true }
        }, [calendarId, currentMonthDate])

        return (
            <CalendarFormRender
                value={value}
                onChange={(_value) => {
                    if (onChange) {
                        onChange(_value)
                    }
                    formPlugin.rerenderProducts()
                }}
                slots={slots}
                onChangePanel={(_date) => setCurrentMonthDate(_date)}
            />
        )
    }
}
